import { usePromptStore } from '@/components/prompt-dialog/store';

const isObject = (obj: unknown): obj is Record<string, unknown> => {
  return typeof obj === 'object' && obj !== null;
};

const checkParsedError = (err: unknown) => {
  if (!isObject(err)) {
    return false;
  }

  if (!err) {
    return false;
  }

  if ('mt_motivation' in err) {
    return true;
  }

  if (
    '__all__' in err &&
    typeof err['__all__'] === 'string' &&
    err['__all__']?.includes('(1013)')
  ) {
    return true;
  }

  return false;
};

export function parsedErrorNeedsMotivation(parsedError: unknown): boolean {
  if (Array.isArray(parsedError)) {
    return parsedError.some((entry) => checkParsedError(entry));
  }
  return checkParsedError(parsedError);
}

/**
 * Ask the user for an approval motivation (backend error 1013). Resolves
 * the entered text, or `null` when the user declines.
 */
export const requestUserMotivation = (): Promise<string | null> =>
  usePromptStore.getState().request({ type: 'motivation' });
